import clsx from "clsx";

import type { JSX, ReactNode } from "react";

export interface DetailItemProps {
  label: string;
  icon: JSX.Element;
  children: ReactNode;
  isColumn?: boolean;
  tooltip?: ReactNode;
}

export default function DetailItem({
  label,
  icon,
  children,
  isColumn = false,
  tooltip,
}: DetailItemProps) {
  return (
    <div
      className={clsx(
        "flex px-4 justify-between border-b border-b-black-200",
        isColumn ? "flex-col pt-2.5 pb-4 gap-y-2.5" : "py-2 items-center",
      )}
    >
      <div className="gap-x-1.5 flex text-button-sm [&>svg]:size-5">
        {icon}
        {label}
        {tooltip}
      </div>

      {children}
    </div>
  );
}
